import {
  Avatar,
  Button,
  Col,
  Drawer,
  Input,
  List,
  Row,
  Select,
  Space,
  Spin,
  Steps,
  Tag,
  Tooltip,
} from "antd";
import { useMutation, useQuery } from "react-query";
import { useParams } from "react-router-dom";
import { getOption, getSingleArticle } from "../../actions/my-orders/services";
import { LoadingOutlined } from "@ant-design/icons";
import proto_illustration from "../../img/Prototype.svg";
import backArrow from "../../img/backArrow.png";
import { history } from "../..";
import OrderServices from "../../actions/order-actions/services";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Collapse } from "antd";
import {
  faCaretDown,
  faFilePdf,
  faImage,
} from "@fortawesome/free-solid-svg-icons";

import { CheckOutlined } from "@ant-design/icons";
import moment from "moment";
import { CancelOrderDrawer } from "../../components/MyOrderConfirmation/CancelOrderDrawer";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";
import {
  approveOptionAndComment,
  rejectOrAcceptProto,
} from "../../actions/order-actions/actions";
import { MyNotif } from "../../components/NotifIcons/NotifIcons";
import "../../sass/MyOrderDetails.scss";
import { FileLightBox } from "../../components/OrderDetails/FileLightBox";

const { Step } = Steps;
const { Option } = Select;
const { Panel } = Collapse;
export default function DirectOrderProgress() {
  const [isOwner, setIsOwner] = useState(false);
  const [quantity, setQuantity] = useState("");
  const [size_qty, setSizeQty] = useState("");
  const [delivery_date, setDeliviry_date] = useState("");

  const [comment, setComment] = useState("");
  const [isVisible, setIsVisible] = useState(false);
  const [notApproveIsVisible, setNotApproveIsVisible] = useState(false);
  const [approved, setApproved] = useState(false);
  const width = useBreakpoint();

  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);

  const showDrawer = () => {
    setOpen(true);
  };

  const showDrawer2 = () => {
    setOpen2(true);
  };
  const onClose = () => {
    setOpen(false);
  };

  const { user } = useSelector((state: any) => state.auth);

  const {
    id: order_id,
    article_id,
    option_id,
  } = useParams<{ id: string; article_id: string; option_id: string }>();

  const {
    data: option,
    isLoading: loadingOption,
    refetch,
  } = useQuery(`option-${option_id}`, () => getOption(option_id));
  const { data: article, isLoading: loadingArticle } = useQuery(
    `article-${article_id}`,
    () => getSingleArticle(article_id)
  );
  const { data: order, isLoading: loadingOrder } = useQuery(
    `order-${order_id}`,
    () => OrderServices.getOneOrder(order_id)
  );

  useEffect(() => {
    if (order) {
      setIsOwner(order?.data.client.id === user.id);
    }
  }, [order]);

  const selectHandleChange = (e: any) => {
    setQuantity(e.target.value);
    console.log(quantity);
  };

  const showCancelDrawer = () => {
    setIsVisible(true);
  };

  const notApprovedOption = async (feedback: string = "") => {
    console.log(`Option ${option?.data.name} is not approved!!`);
    if (!feedback) {
      approveOptAndComment({
        article_option_id: option_id,
        comment: `Not Approved: ${comment}`,
        status_id: 6,
      });
    } else {
      await approveOptAndComment({
        article_option_id: option_id,
        comment: `Not Approved: ${comment}`,
        status_id: 6,
        feedback,
      });
    }
    await rejectOrAcceptPrototype({
      response: "reject",
      id: +option_id,
      comment: `Not Approved: ${comment}`,
    });

    setIsVisible(false);
    setComment("");
    setNotApproveIsVisible(true);
    setTimeout(() => {
      setNotApproveIsVisible(false);
    }, 2000);
  };

  const approveArticleAndSetQuantity = async () => {
    console.log(
      `Option ${option?.data.name} is approved and the quantity is ${quantity}!!`
    );
    await approveOption();
    await setQuantity("");
  };

  const approveOption = async () => {
    setNotApproveIsVisible(true);
    setApproved(true);
    await approveOptAndComment({
      article_option_id: option_id,
      comment: `Approved: ${comment}`,
      status_id: option?.data.status.id,
      qty:
        option?.data.status.name === "SMS" ||
        option?.data.status.name === "OK PROD" ||
        option?.data.status.name === "PRE SMS" ||
        option?.data.status.name === "PRODUCTION"
          ? Number(quantity)
          : 0,
      size_qty:
        option?.data.status.name === "SMS" ||
        option?.data.status.name === "OK PROD" ||
        option?.data.status.name === "PRE SMS" ||
        option?.data.status.name === "PRODUCTION"
          ? size_qty
          : null,

      delivery_date:
        option?.data.status.name === "SMS" ||
        option?.data.status.name === "OK PROD" ||
        option?.data.status.name === "PRE SMS" ||
        option?.data.status.name === "PRODUCTION"
          ? delivery_date
          : null,
    });
    await rejectOrAcceptPrototype({
      response: "accept",
      id: +option_id,
      comment: `Approved: ${comment}`,
    });
    console.log(
      `Option ${option?.data.name} is approved and comment is created!!`
    );
    setIsVisible(false);
    setComment("");
    setTimeout(() => {
      setNotApproveIsVisible(false);
    }, 2000);
  };

  const {
    mutateAsync: approveOptAndComment,
    isLoading: approvingAndCommentLoading,
  } = useMutation(approveOptionAndComment);
  const {
    mutateAsync: rejectOrAcceptPrototype,
    isLoading: rejectOrAcceptProtoLoading,
  } = useMutation(rejectOrAcceptProto, {
    onSuccess: (res) => {
      MyNotif(`Option ${res}ed and comments added successfully`, "success");
      refetch();
    },
  });
  const [step, setSetp] = useState(option?.data.status.pivot.name);

  if (loadingOption || loadingOrder) {
    return (
      <div
        style={{ width: "100%", height: "50vh" }}
        className="d-flex justify-content-center align-items-center"
      >
        <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
      </div>
    );
  }

  return (
    <div className="container-fluid">
      <div className="row pt-0">
        <div
          className="col-12 col-md-5 p-0  align-items-center"
          style={{ background: "#fcfdff", height: "100%" }}
        >
          <iframe
            src={
              option?.data.status.pivot.proto
                ? option?.data.status.pivot.proto
                : proto_illustration
            }
            style={{
              width: "100%",
              height: "calc(100vh - 227px)",
              border: "none",
            }}
          />

          {/* <img
            src={
              option?.data.proto
                ? process.env.REACT_APP_STORAGE_URL + option?.data.proto
                : proto_illustration
            }
            alt="prototype"
            className="proto_img img-fluid"
            style={{
              objectFit: option?.data.proto ? "contain" : "cover",
            }}
          /> */}
          {/*    <div
            className="row "
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <button onClick={showDrawer}>View product details</button>{" "}
          </div>
          <div
            className="row"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <button onClick={showDrawer2}>Export All </button>{" "}
          </div> */}
        </div>
        <div className="col-12 col-md-7 proto_container pl-3">
          <div className="proto_header m-4">
            <img
              src={backArrow}
              className="back_arrow_folder"
              alt="back arrow"
              onClick={() => history.back()}
            />
            {loadingArticle ? (
              <h1>My orders</h1>
            ) : (
              <>
                <h1>{article?.data.name}</h1>
                {/*  {option?.data.status.pivot.proto_confirmation ===
                  "ACCEPTED" && (
                  <div className="col-2">
                    <Tag
                      icon={
                        <CheckOutlined
                          style={{
                            top: "10px",
                            position: "absolute",
                            left: "19px",
                          }}
                        />
                      }
                      style={{
                        borderRadius: "15px",
                        padding: "5px 9px 5px 9px",
                      }}
                      color="green"
                    >
                      Approved
                    </Tag>
                  </div>
                )} */}
                <div style={{ position: "absolute", right: "10px" }}>
                  <Avatar.Group
                    maxCount={5}
                    size="large"
                    maxStyle={{ color: "#f56a00", backgroundColor: "#fde3cf" }}
                  >
                    {order?.data.collaborators.map((colab: any) => (
                      <Tooltip
                        title={colab.name}
                        placement="bottom"
                        key={colab.id}
                      >
                        <Avatar
                          src={process.env.REACT_APP_STORAGE_URL + colab.logo}
                        />
                      </Tooltip>
                    ))}
                  </Avatar.Group>
                </div>
              </>
            )}
          </div>
          <div className="proto_breadcrumb_container my-4">
            <div className="d-flex align-items-center mb-2">
              <Avatar
                src={
                  process.env.REACT_APP_STORAGE_URL + order?.data.client.logo
                }
                size="default"
              />
              <p className="proto_breadcrumb mb-0 ml-2">{`${order?.data.client.name} > ${order?.data.name} > ${article?.data.name} > ${option?.data.name}`}</p>
              {/*               <div style={{ position: "absolute", right: "10px" }}>New</div>
               */}{" "}
            </div>
            {option?.data.status.id !== 6 && (
              <>
                <p className="proto_msg_welcome">
                  Welcome, we are waiting for your confirmation.
                </p>
                <p>Click on the step to view dates details</p>
              </>
            )}
          </div>
          <div className="steps_progress mt-4 d-flex justify-content-center">
            <Steps
              className={
                option?.data.status.id === 6
                  ? "d-flex justify-content-center cancelled"
                  : ""
              }
              current={option?.data.status.id - 1}
              labelPlacement={"vertical"}
              direction={width.md ? "horizontal" : "vertical"}
            >
              {option?.data.status.id !== 6 ? (
                <>
                  <Step
                    title="PROTO"
                    onClick={() => setSetp("PROTO")}
                    style={{
                      cursor: option?.data.status.id >= 1 ? "pointer" : "",
                    }}
                    description={
                      option?.data.status.id >= 1 ? "View details" : ""
                    }
                  />
                  <Step
                    title="PRE SMS"
                    onClick={() => setSetp("PRE SMS")}
                    style={{
                      cursor: option?.data.status.id >= 2 ? "pointer" : "",
                    }}
                    description={
                      option?.data.status.id >= 2 ? "View details" : ""
                    }
                  />
                  <Step
                    title="SMS"
                    onClick={() => setSetp("SMS")}
                    style={{
                      cursor: option?.data.status.id >= 3 ? "pointer" : "",
                    }}
                    description={
                      option?.data.status.id >= 3 ? "View details" : ""
                    }
                  />
                  <Step
                    title="OK PROD"
                    onClick={() => setSetp("OK PROD")}
                    style={{
                      cursor: option?.data.status.id >= 4 ? "pointer" : "",
                    }}
                    description={
                      option?.data.status.id >= 4 ? "View details" : ""
                    }
                  />
                  <Step
                    title="PRODUCTION"
                    style={{
                      cursor: option?.data.status.id >= 5 ? "pointer" : "",
                    }}
                    onClick={() => setSetp("PRODUCTION")}
                    description={
                      option?.data.status.id >= 5 ? "View details" : ""
                    }
                  />
                </>
              ) : (
                <Step title="CANCELLED" />
              )}
            </Steps>
          </div>
          <>
            {" "}
            <div className="proto_footer mt-5">
              <table
                className="table_production "
                style={{
                  marginBottom: "25px",
                  borderRadius: "1em",
                }}
              >
                <tr className="border">
                  <th className="border-right p-3" style={{ width: "300px" }}>
                    Style
                  </th>
                  <td className="p-3" style={{ width: "300px" }}>
                    {(option?.data.style_file !== null &&
                      (option?.data.style_file.slice(-4) == ".pdf" ? (
                        <a
                          href={
                            process.env.REACT_APP_STORAGE_URL +
                            option?.data.style_file
                          }
                          className="
                           text-center"
                          target="_blank"
                          style={{
                            textDecoration: "none",
                            color: "#00468C",
                          }}
                        >
                          {option && option?.data.style}{" "}
                          <FontAwesomeIcon icon={faFilePdf} />
                        </a>
                      ) : (
                        <>
                          <a
                            href={
                              process.env.REACT_APP_STORAGE_URL +
                              option?.data.style_file
                            }
                            className="
                           text-center"
                            target="_blank"
                            style={{
                              textDecoration: "none",
                              color: "#00468C",
                            }}
                          >
                            {option && option?.data.style}{" "}
                            <FontAwesomeIcon icon={faImage} />
                          </a>
                        </>
                      ))) || <>{option?.data.style}</>}
                  </td>
                </tr>

                <tr className="border">
                  <th className="border-right p-3">Fabric</th>
                  <td className="p-3" style={{ width: "300px" }}>
                    {(option?.data.fabric_file !== null &&
                      (option?.data.fabric_file.slice(-4) == ".pdf" ? (
                        <a
                          href={
                            process.env.REACT_APP_STORAGE_URL +
                            option?.data.fabric_file
                          }
                          className="
                           text-center"
                          target="_blank"
                          style={{
                            textDecoration: "none",
                            color: "#00468C",
                          }}
                        >
                          {option && option?.data.fabric}{" "}
                          <FontAwesomeIcon icon={faFilePdf} />
                        </a>
                      ) : (
                        <>
                          <a
                            href={
                              process.env.REACT_APP_STORAGE_URL +
                              option?.data.fabric_file
                            }
                            className="
                           text-center"
                            target="_blank"
                            style={{
                              textDecoration: "none",
                              color: "#00468C",
                            }}
                          >
                            {option && option?.data.fabric}{" "}
                            <FontAwesomeIcon icon={faImage} />
                          </a>
                        </>
                      ))) || <>{option?.data.fabric}</>}
                  </td>
                </tr>

                <tr className="border">
                  <th className="border-right p-3">Wash</th>
                  <td className="p-3" style={{ width: "300px" }}>
                    {(option?.data.wash_file !== null &&
                      (option?.data.wash_file.slice(-4) == ".pdf" ? (
                        <a
                          href={
                            process.env.REACT_APP_STORAGE_URL +
                            option?.data.wash_file
                          }
                          className="
                           text-center"
                          target="_blank"
                          style={{
                            textDecoration: "none",
                            color: "#00468C",
                          }}
                        >
                          {option && option?.data.wash}{" "}
                          <FontAwesomeIcon icon={faFilePdf} />
                        </a>
                      ) : (
                        <>
                          <a
                            href={
                              process.env.REACT_APP_STORAGE_URL +
                              option?.data.wash_file
                            }
                            className="
                           text-center"
                            target="_blank"
                            style={{
                              textDecoration: "none",
                              color: "#00468C",
                            }}
                          >
                            {option && option?.data.wash}{" "}
                            <FontAwesomeIcon icon={faImage} />
                          </a>
                        </>
                      ))) || <>{option?.data.wash}</>}
                  </td>
                </tr>

                <tr className="border">
                  <th className="border-right p-3">Trims</th>
                  <td className="p-3" style={{ width: "300px" }}>
                    {(option?.data.trims_file !== null &&
                      (option?.data.trims_file.slice(-4) == ".pdf" ? (
                        <a
                          href={
                            process.env.REACT_APP_STORAGE_URL +
                            option?.data.trims_file
                          }
                          className="
                           text-center"
                          target="_blank"
                          style={{
                            textDecoration: "none",
                            color: "#00468C",
                          }}
                        >
                          {option && option?.data.trims}{" "}
                          <FontAwesomeIcon icon={faFilePdf} />
                        </a>
                      ) : (
                        <>
                          <a
                            href={
                              process.env.REACT_APP_STORAGE_URL +
                              option?.data.trims_file
                            }
                            className="
                           text-center"
                            target="_blank"
                            style={{
                              textDecoration: "none",
                              color: "#00468C",
                            }}
                          >
                            {option && option?.data.trims}{" "}
                            <FontAwesomeIcon icon={faImage} />
                          </a>
                        </>
                      ))) || <>{option?.data.trims}</>}
                  </td>
                </tr>

                <tr className="border">
                  <th className="border-right p-3">Thread</th>
                  <td className="p-3" style={{ width: "300px" }}>
                    {(option?.data.thread_file !== null &&
                      (option?.data.thread_file.slice(-4) == ".pdf" ? (
                        <a
                          href={
                            process.env.REACT_APP_STORAGE_URL +
                            option?.data.thread_file
                          }
                          className="
                           text-center"
                          target="_blank"
                          style={{
                            textDecoration: "none",
                            color: "#00468C",
                          }}
                        >
                          {option && option?.data.thread}{" "}
                          <FontAwesomeIcon icon={faFilePdf} />
                        </a>
                      ) : (
                        <>
                          <a
                            href={
                              process.env.REACT_APP_STORAGE_URL +
                              option?.data.thread_file
                            }
                            className="
                           text-center"
                            target="_blank"
                            style={{
                              textDecoration: "none",
                              color: "#00468C",
                            }}
                          >
                            {option && option?.data.thread}{" "}
                            <FontAwesomeIcon icon={faImage} />
                          </a>
                        </>
                      ))) || <>{option?.data.thread}</>}
                  </td>
                </tr>

                {option?.data.allStatus.map((el: any) => {
                  return (
                    <>
                      {el.name == step && el.name != "PROTO" ? (
                        <>
                          {" "}
                          <tr className="border">
                            <th className="border-right p-3">
                              Quantity {el.name}
                            </th>
                            <td className="p-3">
                              {el.pivot.qty != 1 ? el.pivot.qty : "-"}
                            </td>
                          </tr>
                          <tr className="border">
                            <th className="border-right p-3">
                              Size's quantity {el.name}
                            </th>
                            <td className="p-3">{el.pivot.size_qty || "-"}</td>
                          </tr>
                        </>
                      ) : (
                        <></>
                      )}
                    </>
                  );
                })}
                {step == "PROTO" && (
                  <>
                    {" "}
                    <tr className="border">
                      <th className="border-right p-3">Quantity Proto</th>
                      <td className="p-3">{option && option.data.qty}</td>
                    </tr>
                    <tr className="border">
                      <th className="border-right p-3">
                        Size's quantity Proto
                      </th>
                      <td className="p-3">{option && option.data.size_qty}</td>
                    </tr>
                  </>
                )}

                <tr className="border">
                  <th className="border-right p-3">Length</th>
                  <td className="p-3">
                    {(option && option.data.crotch) || "-"}
                  </td>
                </tr>

                {/*     <tr className="border">
                  <th className="border-right p-3">Quantity</th>
                  <td className="p-3">
                    {(option && option.data.status.pivot.qty) || "-"}
                  </td>
                </tr>
                <tr className="border">
                  <th className="border-right p-3">Size's quantity</th>
                  <td className="p-3">
                    {(option && option.data.status.pivot.size_qty) || "-"}
                  </td>
                </tr> */}
                {option?.data.allStatus.map((el: any) => {
                  {
                    return (
                      <>
                        {el.name == step ? (
                          <>
                            {/*   <tr className="border">
                              <th className="border-right p-3">
                                Date trims wearhouse
                              </th>
                              <td className="p-3">
                                {option && el.pivot.date_trims_wearhouse
                                  ? moment(
                                      el.pivot.date_trims_wearhouse
                                    ).format("YYYY-MM-DD")
                                  : "-"}
                              </td>
                            </tr>
                            <tr className="border">
                              <th className="border-right p-3">
                                Date fabric wearhouse
                              </th>
                              <td className="p-3">
                                {option && el.pivot.date_fabric_wearhouse
                                  ? moment(
                                      el.pivot.date_fabric_wearhouse
                                    ).format("YYYY-MM-DD")
                                  : "-"}
                              </td>
                            </tr> */}
                            <tr className="border">
                              <th className="border-right p-3">
                                Start production date
                              </th>
                              <td className="p-3">
                                {option && el.pivot.start_production_date
                                  ? moment(
                                      el.pivot.start_production_date
                                    ).format("YYYY-MM-DD")
                                  : "-"}
                              </td>
                            </tr>
                            <tr className="border">
                              <th className="border-right p-3">
                                Shipping date
                              </th>
                              <td className="p-3">
                                {option && el.pivot.shipping_date
                                  ? moment(el.pivot.shipping_date).format(
                                      "YYYY-MM-DD"
                                    )
                                  : "-"}
                              </td>
                            </tr>
                            <tr className="border">
                              <th className="border-right p-3">
                                Delivery date
                              </th>
                              <td className="p-3">
                                {option && el.pivot.delivery_date
                                  ? moment(el.pivot.delivery_date).format(
                                      "YYYY-MM-DD"
                                    )
                                  : "-"}
                              </td>
                            </tr>
                          </>
                        ) : (
                          <></>
                        )}
                      </>
                    );
                  }
                })}
              </table>
            </div>
          </>
          <div className="proto_footer">
            {option?.data.status.id !== 6 && (
              <div className="mt-4">
                {/*                 <h1 className="my-3">{option?.data.name}</h1>
                 */}{" "}
                {/*          <p>{article?.data.description}</p> */}
              </div>
            )}

            {option?.data.status.name !== "CANCELLED" &&
              isOwner &&
              (option?.data.status.name === "SMS" ||
              option?.data.status.name === "OK PROD" ||
              option?.data.status.name === "PRODUCTION" ||
              option?.data.status.name === "PRE SMS" ? (
                <div>
                  {" "}
                  <SelectQuantity
                    quantity={quantity}
                    /*                     value={option.data.status.pivot.qty}
                     */ defaultQty={option.data.status.pivot.qty}
                    selectHandleChange={selectHandleChange}
                  />
                  <div className="final_order_select my-3">
                    <label className="mr-3 mb-0">Size's quantity</label>

                    <Input
                      type="text"
                      name="size_qty"
                      placeholder="S:10;M:10"
                      defaultValue={option.data.status.pivot.size_qty}
                      onChange={(e) => setSizeQty(e.target.value)}
                    ></Input>
                  </div>
                  <div className="final_order_select my-3">
                    <label className="mr-3 mb-0">Delivery date</label>
                    <Input
                      type="date"
                      name="delivery_date"
                      value={
                        delivery_date ||
                        moment(option.data.status.pivot.delivery_date).format(
                          "YYYY-MM-DD"
                        )
                      }
                      onChange={(e) => setDeliviry_date(e.target.value)}
                    ></Input>
                  </div>
                </div>
              ) : option?.data.status.name !== "PRODUCTION" ? (
                <CommentsListAndForm
                  option={option?.data}
                  setComment={setComment}
                  comment={comment}
                  order={order?.data}
                />
              ) : (
                <></>
              ))}
            {isOwner &&
              (option?.data.status.name !== "CANCELLED" ? (
                <div className="proto_footer_btns my-4">
                  <Button
                    type="default"
                    className="cancel_btn"
                    onClick={() => showCancelDrawer()}
                    disabled={option?.data.comments.length > 0}
                  >
                    Cancel
                  </Button>

                  {/*  {(option?.data.status.name === "OK PROD" ||
                    option?.data.status.name === "PROTO") && (
                    <Button
                      type="default"
                      className="cancel_btn"
                      onClick={() =>
                        option?.data.status.name === "PROTO"
                          ? showCancelDrawer()
                          : notApprovedOption()
                      }
                      disabled={option?.data.comments.length > 0}
                    >
                      {option?.data.status.name === "OK PROD"
                        ? "Not Approved"
                        : "Cancel"}
                    </Button>
                  )} */}
                  <Button
                    type="default"
                    className="approve_btn"
                    loading={
                      approvingAndCommentLoading || rejectOrAcceptProtoLoading
                    }
                    onClick={() => {
                      if (option?.data.status.name === "SMS") {
                        approveArticleAndSetQuantity();
                      } else {
                        approveOption();
                      }
                    }}
                    disabled={option?.data.comments.length > 0}
                  >
                    Approve
                  </Button>
                </div>
              ) : (
                <div
                  className="proto_footer_btns my-4"
                  style={{ justifyContent: "center" }}
                >
                  <Button
                    type="default"
                    className="approve_btn"
                    onClick={() => history.back()}
                  >
                    Go back to orders
                  </Button>
                </div>
              ))}
          </div>
        </div>
      </div>
      <CancelOrderDrawer
        isVisible={isVisible}
        setIsVisible={setIsVisible}
        article={article}
        notApprovedOption={notApprovedOption}
        orderType={"direct_order"}
        productToCancel={option?.data.id}
        approvingAndCommentLoading={approvingAndCommentLoading}
        rejectOrAcceptProtoLoading={rejectOrAcceptProtoLoading}
      />
      {/* <NotApprovedDrawer
        notApproveIsVisible={notApproveIsVisible}
        setNotApproveIsVisible={setNotApproveIsVisible}
        approved={approved}
      /> */}

      {/*  view product details*/}
      <Drawer
        title="Product details"
        placement={"bottom"}
        closable={true}
        onClose={onClose}
        visible={open}
      >
        <Collapse defaultActiveKey="1" key="1">
          <Panel header={option?.data.name} key="1" showArrow={false}>
            {option && (
              <div className="row border-top" key={1}>
                <div className="col-12 col-lg-6 border-right p-0">
                  <div className="row">
                    <div className="col-12 p-0">
                      <p className="m-0 p-2 collapse_header border-bottom font-weight-bold">
                        {article?.data.name}
                      </p>
                    </div>
                    <div className="col-12 p-0 border-bottom option_details_collapse">
                      <p className="m-0 p-2">
                        <strong>Style Name: </strong>
                        {option?.data.style}
                      </p>
                    </div>
                    <div className="col-12 p-0 border-bottom option_details_collapse">
                      <p className="m-0 p-2">
                        <strong>Fabric: </strong>
                        {option?.data.fabric}
                      </p>
                    </div>
                    <div className="col-12 p-0 border-bottom option_details_collapse">
                      <p className="m-0 p-2">
                        <strong>Wash: </strong>
                        {option?.data.wash}
                      </p>
                    </div>
                    <div className="col-12 p-0 border-bottom option_details_collapse">
                      <p className="m-0 p-2">
                        <strong>Trims: </strong>
                        {option?.data.trims}
                      </p>
                    </div>
                    <div className="col-12 p-0 border-bottom option_details_collapse">
                      <p className="m-0 p-2">
                        <strong>Thread: </strong>
                        {option?.data.thread}
                      </p>
                    </div>
                    <div className="col-12 p-0 option_details_collapse">
                      <p className="m-0 p-2">
                        <strong>Quantity: </strong>
                        {option?.data.qty}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-lg-6 p-0">
                  <div className="row">
                    <div className="col-12 p-0">
                      <p className="m-0 p-2 collapse_header bg-white border-bottom font-weight-bold">
                        Files
                      </p>
                    </div>
                    <div className="col-12 pt-3 files_wrapper">
                      <div className="row flex-wrap">
                        {[
                          "style_file",
                          "fabric_file",
                          "wash_file",
                          "trims_file",
                          "thread_file",
                        ].map((el: any, i: number) => (
                          <FileLightBox file={option?.data[el]} key={i} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </Panel>
        </Collapse>
      </Drawer>

      <Drawer
        title="Product details"
        placement={"bottom"}
        closable={true}
        onClose={onClose}
        visible={open2}
      >
        eee
      </Drawer>
    </div>
  );
}

const SelectQuantity = ({ quantity, selectHandleChange, defaultQty }: any) => {
  return (
    <div className="final_order_select my-3">
      <label className="mb-0" style={{ marginRight: "60px" }}>
        Quantity
      </label>
      {/*   <Select
        defaultValue={quantity || defaultQty}
        style={{
          width: "100%",
        }}
        onChange={selectHandleChange}
        dropdownStyle={{
          borderRadius: 10,
          fontWeight: 600,
          fontSize: 20,
        }}
        suffixIcon={() => <FontAwesomeIcon icon={faCaretDown} />}
      >
        <Option value="">Select the number of pieces</Option>
        <Option value="1">1 Pc</Option>
        <Option value="2">2 Pcs</Option>
        <Option value="3">3 Pcs</Option>
        <Option value="4">4 Pcs</Option>
        <Option value="5">5 Pcs</Option>
      </Select> */}
      <Input
        type="number"
        defaultValue={quantity || defaultQty}
        onChange={selectHandleChange}
      ></Input>
    </div>
  );
};

const CommentsListAndForm = ({ option, setComment, order, comment }: any) => {
  return (
    <>
      <div>
        <h1 style={{ fontSize: "1rem", fontWeight: 400 }}>Comments: </h1>
        <List
          itemLayout="horizontal"
          dataSource={option.comments}
          renderItem={(item: any) => (
            <List.Item>
              <List.Item.Meta
                avatar={
                  <Avatar
                    src={process.env.REACT_APP_STORAGE_URL + order.client.logo}
                  />
                }
                title={
                  <span>
                    {/* <span>{option.status.name}</span> */}
                    {item.comment.includes("NOT")
                      ? " NOT APPROVED BY "
                      : " APPROVED BY "}
                    {order.client.name}
                  </span>
                }
                description={item.comment}
              />
            </List.Item>
          )}
        />
      </div>
      <textarea
        rows={4}
        name="comment"
        value={comment}
        placeholder="Add a comment"
        className="comment_proto_order my-4"
        onChange={(e: any) => setComment(e.target.value)}
      ></textarea>
    </>
  );
};
